import type { InlineFormSectionFooterProps } from '../../../types/inline-form-section.types';

/** Separate secondary actions and status from the main cancel/save pair. */
export function InlineFormSectionFooter({
  status,
  secondaryAction,
  actions,
}: InlineFormSectionFooterProps) {
  return (
    <div className="flex flex-col gap-3 rounded-b-lg border-t border-secondary-200 bg-secondary-50 px-4 py-3 sm:flex-row sm:items-center sm:px-6">
      {(Boolean(status) || Boolean(secondaryAction)) && (
        <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
          {status && <div aria-live="polite">{status}</div>}
          {secondaryAction}
        </div>
      )}
      {actions && (
        <div className="flex flex-wrap items-center justify-end gap-2 sm:ml-auto sm:shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
